import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { LoadDomainGuard } from './base/load-domain.guard';
import { LoadServicesGuard } from './base/load-services.guard';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PaypalGuard implements CanActivate {

  constructor(
    private loadDomainGuard: LoadDomainGuard,
    private loadServicesGuard: LoadServicesGuard,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  canActivate(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return of(true)
    }
    return this.loadDomainGuard.canActivate().pipe(mergeMap((domainLoaded: boolean) => {
      if (domainLoaded) {
        return this.loadServicesGuard.canActivate().pipe(mergeMap((servicesLoaded: boolean) => {
          if (servicesLoaded) {
            return of(true);
          }
          return of(false);
        }));
      }
    }));
  }

}
